import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=0cbf060c&scoped=true&"
import script from "./ImageGallery.vue?vue&type=script&lang=ts&"
export * from "./ImageGallery.vue?vue&type=script&lang=ts&"
import style0 from "./ImageGallery.vue?vue&type=style&index=0&id=0cbf060c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf060c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsStepper: require('/var/www/packages/theme/components/atoms/Stepper.vue').default,MoleculesKESfGallery: require('/var/www/packages/theme/components/molecules/KESfGallery.vue').default,AtomsKELabel: require('/var/www/packages/theme/components/atoms/KELabel.vue').default,AtomsNavigationButton: require('/var/www/packages/theme/components/atoms/NavigationButton.vue').default})
